import http from '@windsor-telecom/client-core/src/http'

export default {
    async me () {
        try {
            return await http({
                baseURL: process.env.VUE_APP_CC_API_URL
            }).get('/me')
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
